'use client'

import { useEffect } from 'react'

import { useRouter } from 'next/navigation'

import { BookOpen } from 'lucide-react'

import { useAuth } from '@/hooks/useAuth'

export default function HomePage() {
  const { isAuthenticated, loading } = useAuth()
  const router = useRouter()

  useEffect(() => {
    if (!loading) {
      if (isAuthenticated) {
        router.push('/dashboard')
      } else {
        router.push('/auth/login')
      }
    }
  }, [isAuthenticated, loading, router])

  // Show loading state while determining redirect
  return (
    <div className="min-h-page bg-gradient-to-br from-primary/5 to-accent/5 flex items-center justify-center">
      <div className="text-center">
        <div className="relative">
          <BookOpen className="h-12 w-12 text-primary mx-auto mb-4" />
          <div className="absolute inset-0 animate-ping">
            <BookOpen className="h-12 w-12 text-primary/30 mx-auto" />
          </div>
        </div>
        <p className="text-body-lg text-muted-foreground">Loading...</p>
      </div>
    </div>
  )
}
